export type SsrLoaderErrorEntity = 'model' | 'artwork'

export type SsrLoaderErrorReason =
  | 'missing-route-param'
  | 'invalid-route-param'
  | 'fetch-failed'
  | 'primary-data-missing'
  | 'private-entity'
  | 'missing-version'
  | 'archived-entity'

export interface SsrLoaderErrorData {
  kind: 'ssr-loader-error'
  entity: SsrLoaderErrorEntity
  reason: SsrLoaderErrorReason
  detail: string
}

const ERROR_DETAILS: Record<SsrLoaderErrorEntity, string> = {
  model:
    'Model page data is temporarily unavailable. Please refresh and try again.',
  artwork:
    'Artwork page data is temporarily unavailable. Please refresh and try again.',
}

export function createSsrLoaderErrorData(
  entity: SsrLoaderErrorEntity,
  reason: SsrLoaderErrorReason,
): SsrLoaderErrorData {
  return {
    kind: 'ssr-loader-error',
    entity,
    reason,
    detail: ERROR_DETAILS[entity],
  }
}

export function hasSsrLoaderError(
  data: unknown,
): data is { ssrLoadError: SsrLoaderErrorData } {
  if (!data || typeof data !== 'object') return false
  const ssrLoadError = (data as Record<string, unknown>).ssrLoadError
  return (
    !!ssrLoadError &&
    typeof ssrLoadError === 'object' &&
    (ssrLoadError as { kind?: unknown }).kind === 'ssr-loader-error'
  )
}
